import { useRef } from "react";
import useStore from "../AppStore";
import { lerp, useAnimationFrame } from "../util";

export default function AudioViz(props) {

  const lineRef1 = useRef(null);
  const lineRef2 = useRef(null);
  const lineRef3 = useRef(null);
  const lineRef4 = useRef(null);
  const lineRef5 = useRef(null);
  const lineRef6 = useRef(null);
  const lineRef7 = useRef(null);
  const lineRef8 = useRef(null);
  const lineRef9 = useRef(null);
  const lineRef10 = useRef(null);

  useAnimationFrame((clock) => {
    const items = [
      lineRef1,
      lineRef2,
      lineRef3,
      lineRef4,
      lineRef5,
      lineRef6,
      lineRef7,
      lineRef8,
      lineRef9,
      lineRef10
    ];
    if (useStore.getState().audioPlay) {
      items.map((item, i) => {
        const s = 2 + Math.sin(clock.elapsedTime * 6 + i / 1) * 1;
        if(item.current){
          const s2 = lerp(Number(item.current.dataset.sy), s, 0.1);
          item.current.style.transform = `scale(1,${s2})`;
          item.current.dataset.sy = s2;
        }
      });
    } else {
      items.map((item, i) => {
        if(item.current){
          const s2 = lerp(Number(item.current.dataset.sy), 1, 0.2);
          item.current.style.transform = `scale(1,${s2})`;
          item.current.dataset.sy = s2;
        }
      });
    }
  }, []);

  return (
    <div className="audioviz" {...props}>
      <div ref={lineRef1} className="audioviz--line" data-sy={1} />
      <div ref={lineRef2} className="audioviz--line" data-sy={1} />
      <div ref={lineRef3} className="audioviz--line" data-sy={1} />
      <div ref={lineRef4} className="audioviz--line" data-sy={1} />
      <div ref={lineRef5} className="audioviz--line" data-sy={1} />
      <div ref={lineRef6} className="audioviz--line" data-sy={1} />
      <div ref={lineRef7} className="audioviz--line" data-sy={1} />
      <div ref={lineRef8} className="audioviz--line" data-sy={1} />
      <div ref={lineRef9} className="audioviz--line" data-sy={1} />
      <div ref={lineRef10} className="audioviz--line" data-sy={1} />
    </div>
  );
}